import { branch, renderNothing } from 'recompose'

import { debug } from '@monorepo/core/config'
import Metrics from './Metrics'

export default branch(() => debug, renderNothing)(Metrics)
